import React, { ReactElement } from 'react';
import { STANDARD_CARD_UK_MOBILE } from 'clientState/ab/aliases';
import UKNoPrimeFareMessage from '@components/Results/Components/ThreeColumnsItinerary/UKNoPrimeFareMessage';
import { createFeature } from '@edreamsodigeo/frontend-core';
import { FooterCard } from '@edreamsodigeo/prisma-design-system';

export const ItineraryFooterFullPrimePrice = ({
  onClick,
  isAlternativeItinerary,
}): ReactElement => {
  return (
    <FooterCard onClick={onClick}>
      <UKNoPrimeFareMessage isAlternativeItinerary={isAlternativeItinerary} />
    </FooterCard>
  );
};

export const ItineraryFooterComponent = createFeature({
  name: STANDARD_CARD_UK_MOBILE,
  variations: [ItineraryFooterFullPrimePrice, null],
  version: 1,
});
